/**
 * Copyright 2019 Atelier Disko. All rights reserved. This source
 * code is distributed under the terms of the BSD 3-Clause License.
 */

import React, { useState } from 'react';
import './DpaColorCard.css';
import { copyTextToClipboard } from '../utils';
import contrast from 'get-contrast';
import ColorCard from '../ColorCard';

function DpaColorCard(props) {
  return (
    <div className="dpa-color-card">
      <ColorCard {...props} />
      {props.colordark && <ColorCard {...props} color={props.colordark}>{`${props.children}-dark`}</ColorCard>}
    </div>
  );
}

export default DpaColorCard;

const isColor = strColor => {
  const s = new Option().style;
  s.color = strColor;
  return s.color !== '';
};
